import React from 'react';

import { Icon, IconName } from 'ui';

import './_empty-state.scss';

type EmptyStateVariant = 'success' | 'warning' | 'muted' | 'info' | 'error' | 'neutral' | 'strengths';

type EmptyStateProps = {
  description: string;
  iconType?: IconName;
  iconVariant?: EmptyStateVariant;
  title: string;
};

function EmptyState({ description, iconType, iconVariant, title }: Readonly<EmptyStateProps>): JSX.Element {
  const hasIcon = !!iconType && !!iconVariant;

  return (
    <div className="empty-state">
      {hasIcon && (
        <div className={`empty-state__icon empty-state__icon--${iconVariant}`}>
          <Icon size="md" name={iconType} />
        </div>
      )}
      <h3 className="empty-state__title">{title}</h3>
      <p className="empty-state__description">{description}</p>
    </div>
  );
}

export default EmptyState;
